import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { MediaType } from '@klickdata/core/media/src/media-type';
import { ResourceItem, ResourceItemService } from '@klickdata/core/resource-item';
import { filter, map, Observable, of, tap } from 'rxjs';

@Component({
    selector: 'app-material-welcome-type-parent-shared',
    templateUrl: './material-welcome-type-parent-shared.component.html',
    styleUrls: ['./material-welcome-type-parent-shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialWelcomeTypeParentSharedComponent implements OnInit, OnChanges {
    @Input() parentItem: ResourceItem;
    @Output() setCloseEnable: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('parentWrapper', { static: false }) parentWrapperRef!: ElementRef<HTMLDivElement>;
    @ViewChild('floatingControls', { static: false }) floatingControlsRef!: ElementRef<HTMLDivElement>;
    public items$: Observable<{ item: ResourceItem; show: boolean }[]>;
    public leftSideItemsDisplay: { item: ResourceItem; show: boolean }[] = [];
    public rightSideItemsDisplay: { item: ResourceItem; show: boolean }[] = [];
    public isOneColumnDisplay: boolean = false;

    constructor(protected resourceItemService: ResourceItemService) {}

    ngOnInit(): void {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['parentItem']) {
            this.clearItems();
            this.items$ = this.resourceItemService.getResourceItemsByParentItemId(this.parentItem.id).pipe(
                map((items) =>
                    items.filter(
                        (item) => !item.metadata || !item.metadata?.visibility || !!item.metadata?.visibility?.item
                    )
                ),
                map((items) => {
                    const resItems = items.map((item) => {
                        if (
                            (item.metadata?.layout?.align && item.metadata.layout.align === 'right') ||
                            item.mediaData.type === MediaType.IMAGE ||
                            item.mediaData.type === MediaType.VIDEO ||
                            item.mediaData.type === MediaType.AUDIO
                        ) {
                            this.rightSideItemsDisplay.push({ item: item, show: true });
                        } else {
                            this.leftSideItemsDisplay.push({ item: item, show: true });
                        }
                        return { item: item, show: true };
                    });
                    return resItems;
                }),
                tap((items) => {
                    this.setCloseEnable.emit(true);
                    setTimeout(() => {
                        this.syncFloatingWidth();
                    }, 1000);
                    this.isOneColumnDisplay =
                        this.leftSideItemsDisplay.length === 0 || this.rightSideItemsDisplay.length === 0;
                })
                // shareReplay()
            );
        }
    }
    private clearItems() {
        this.items$ = of(null);
        this.leftSideItemsDisplay = [];
        this.rightSideItemsDisplay = [];
    }
    @HostListener('window:resize')
    onWindowResize() {
        this.syncFloatingWidth();
    }
    private syncFloatingWidth(): void {
        if (this.parentWrapperRef && this.floatingControlsRef) {
            const parentRect = this.parentWrapperRef.nativeElement.getBoundingClientRect();
            const floatingEl = this.floatingControlsRef.nativeElement;

            floatingEl.style.width = `${parentRect.width}px`;
            floatingEl.style.left = `${parentRect.left + window.scrollX}px`;
            floatingEl.style.display = 'flex';
        }
    }
    toggleItem(item: ResourceItem) {
        const itemIndex = this.leftSideItemsDisplay.findIndex((i) => i.item.id === item.id);
    }

    onMediaCompleted(item: ResourceItem, event: any) {
        console.log(item, event);
    }

    onClosing(item: ResourceItem) {
        console.log(item);
    }

    onPlayerReady(item: ResourceItem) {
        console.log(item);
    }

    onMediaUpdated(item: ResourceItem, event: any) {
        console.log(item, event);
    }
}
